import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { AnimateAppearanceWrapper } from "../../../../components/animate-appearence/AnimateAppearanceWrapper";
import { PageTitle } from "../../../../components/ui-kit";
import { AppRoutes } from "../../../../constants/routes";
import api from "../../../../util/api";
import ProductDetails from "../components/Details";
import { isNotFoundApiError } from "../../../../util/apiErrorMessage";
import PageNotFound from "../../../../components/page-not-found";

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const TopLine = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  @media (max-width: 900px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const ProductInfo: React.FunctionComponent = () => {
  const { productId } = useParams();
  const [productDetails, setProductDetails] = useState<any>();
  const [notFound, setNotFound] = useState(false);
  const [fatalError, setFatalError] = useState<unknown>(null);
  const navigate = useNavigate();

  useEffect(() => {
    getProduct(productId!);
  }, [productId]);
  const getProduct = async (productId: string) => {
    setNotFound(false);
    setFatalError(null);
    try {
      const result = await api.getProductById(productId);
      setProductDetails(result);
    } catch (e: unknown) {
      if (isNotFoundApiError(e)) {
        setNotFound(true);
        return;
      }
      setFatalError(e);
    }
  };

  if (fatalError) {
    throw fatalError;
  }

  if (notFound) {
    return <PageNotFound />;
  }

  return (
    <>
      {productDetails && (
        <AnimateAppearanceWrapper>
          <Container>
            <TopLine>
              <PageTitle
                onBack={() => {
                  navigate(AppRoutes.Private.Inventory.PRODUCT_LIST);
                }}
                title={`Product variant ${productId}`}
                // subtitle="Whole data about your business here"
              />
            </TopLine>
            <ProductDetails data={productDetails} />
          </Container>
        </AnimateAppearanceWrapper>
      )}
    </>
  );
};
